import { ReactNode, useDeferredValue } from 'react'
import { Typography } from '@mui/material'
import { TextParser } from '@weblite/web-textparser'
import { EmbeddedLink, IMessage } from '@weblite/ts-action/message'
import { hyperLinkViewer } from '$common/hyperLink-viewer'
import { EMOJI_SPRITE_SHEET } from '$helper/constants/emoji'
import { linkViewer } from '$common/link-viewer/link-viewer'
import { t } from '$i18n'

const parsers = [
  {
    name: 'emoji',
    args: { spritesheeturl: EMOJI_SPRITE_SHEET },
  },
  'code',
  { name: 'hyperLink', fn: hyperLinkViewer },
  { name: 'customLink', fn: linkViewer },
]

const messageTypeMapper: Record<IMessage['type'], string> = {
  VOICE: t('message.VOICE'),
  VIDEO: t('message.VIDEO'),
  WAPP: t('message.WAPP'),
  FILE: t('message.FILE'),
  IMAGE: t('message.IMAGE'),
  AUDIO: t('message.AUDIO'),
  CONTACT: t('message.CONTACT'),
  EVENT: '',
  CALL: '',
  TEXT: '', // to not return null when all props are null
}

interface Props {
  body?: string
  type?: IMessage['type']
  event?: string
  draft?: string
  messageAction?: ReactNode
  hasUnseen?: boolean
  links?: EmbeddedLink[]
}

export function Message({
  body = '',
  type = 'TEXT',
  event = '',
  draft = '',
  messageAction = null,
  hasUnseen = false,
  links = [],
}: Props) {
  const deferredBody = useDeferredValue(
    (hasUnseen ? body : draft) || event || body || messageTypeMapper[type],
  )

  return messageAction || deferredBody ? (
    <Typography
      variant="body3"
      color={
        messageAction
          ? 'primary'
          : draft
          ? 'neutral500'
          : event || type === 'CALL'
          ? 'primary'
          : 'neutral500'
      }
      sx={{ width: '100%', '--emoji-size': '18px' }}
      noWrap
    >
      {messageAction || (
        <TextParser
          text={deferredBody}
          parsers={parsers}
          links={links.map(({ url }) => url)}
        />
      )}
    </Typography>
  ) : null
}
